export enum AccountCategory {
  BaseLedger = 'BaseLedger',
  Payment = 'Payment',
  Linked = 'Linked',
  Clearing = 'Clearing',
}

/**
 * An error thrown when an account violates the mutual exclusion property of account
 * categories — it sets more than one of payment/linked/clearing.
 */
export class AccountCategoryMutualExclusionError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'AccountCategoryMutualExclusionError';
  }
}

/**
 * Returns a schema account's {@link AccountCategory}, throwing if the account
 * sets more than one of payment/linked/clearing.
 *
 * The account input shape lets a user to set multiple categories.
 * `getSchemaAccountCategory` both returns the category and enforces that a valid account is only ever at most one.
 */
export const getSchemaAccountCategory = ({
  payment,
  linkedAccount,
  clearing,
}: {
  payment?: unknown;
  linkedAccount?: unknown;
  clearing?: boolean;
}): AccountCategory => {
  if ([payment, linkedAccount, clearing].filter(Boolean).length > 1) {
    throw new AccountCategoryMutualExclusionError();
  }

  if (payment) return AccountCategory.Payment;
  if (linkedAccount) return AccountCategory.Linked;
  if (clearing) return AccountCategory.Clearing;

  return AccountCategory.BaseLedger;
};
